import Routes from 'components/common/Routes'

// svc-data-integrations sends the user back to this platform once the external
// authorisation finished, so every start url carries our callback.
const integrationStartUrl = (externalUrl: string): string => (
  `${externalUrl}&external_callback_url=${process.env.HOST_URL as string}${Routes.addedIntegration}`
)

export default integrationStartUrl
